import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-32d64a96"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", null, "测试页面22", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_button = _resolveComponent("el-button");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("h2", null, "content:" + _toDisplayString(_ctx.store.content), 1),
        _createElementVNode("h2", null, "count:" + _toDisplayString(_ctx.store.count), 1),
        _createElementVNode("h2", null, "隐藏手机号:" + _toDisplayString(_ctx.store.phoneHidden), 1),
        _createElementVNode("h2", null, "隐藏手机号2:" + _toDisplayString(_ctx.store.phoneHidden), 1),
        _createElementVNode("h2", null, "songsStore:" + _toDisplayString(_ctx.store.getSongsList), 1),
        _createElementVNode("h2", null, "text:" + _toDisplayString(_ctx.text), 1),
        _createElementVNode("h2", null, "text1:" + _toDisplayString(_ctx.text1), 1),
        _createElementVNode("h2", null, "textList:" + _toDisplayString(_ctx.textList), 1),
        _createVNode(_component_el_button, { onClick: _ctx.updateContent }, {
            default: _withCtx(() => [
                _createTextVNode("修改content")
            ]),
            _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, { onClick: _ctx.updateCount }, {
            default: _withCtx(() => [
                _createTextVNode("count+1")
            ]),
            _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, { onClick: _ctx.updatePatch }, {
            default: _withCtx(() => [
                _createTextVNode("批量修改")
            ]),
            _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, { onClick: _ctx.updatePatchUseAction }, {
            default: _withCtx(() => [
                _createTextVNode("actions批量修改")
            ]),
            _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, { onClick: _ctx.updatePhone }, {
            default: _withCtx(() => [
                _createTextVNode("手机号修改")
            ]),
            _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, { onClick: _ctx.updateText }, {
            default: _withCtx(() => [
                _createTextVNode("修改文本内容")
            ]),
            _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, { onClick: _ctx.updateTextList }, {
            default: _withCtx(() => [
                _createTextVNode("修改数组")
            ]),
            _: 1
        }, 8, ["onClick"])
    ]));
}
